import client from "api/config";
import { convertNum } from "helper/convert-num";

//////////////////// users ////////////////////

const usersUrl = "/admin/users";

// get all users
export const getAllUsersRequest = (values) => client.get(usersUrl, values);

// get user by id
export const getUserByIdRequest = (values) =>
  client.get(`${usersUrl}/${values.id}`);

//update user by id
export const updateUserByIdRequest = (values) => {
  return client.put(`${usersUrl}/${values.id}`, values);
};
